import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react';
import config from '../config.json';
import axiosAuth from '../utils/axiosAuth';

const LoginInput = ({ playerOptions, teamData, nextGameData, setTeamData, setNextGameData }) => {
    const [ loginValue, setLoginValue ] = useState(null);
    const [ loginInputValue, setLoginInputValue ] = useState('');
    const [ loginMessage, setLoginMessage ] = useState('');
    const [ loginMessageError, setLoginMessageError ] = useState(false);
    const [ isLoggingIn, setIsLoggingIn ] = useState(false);
    const environment = process.env.REACT_APP_ENV;
    const baseApiUrl = environment ? config[environment].apiUrl : config.dev.apiUrl;
    const teamApiUrl = baseApiUrl + `teams/${teamData.id}`
    const gameApiUrl = teamApiUrl + `/games/${encodeURIComponent(nextGameData.dateTimeLocKey)}`;
    const loginPlayerApiUrl = gameApiUrl + '/login/';

    const printUnsuccesfulLoginMessage = (msg) => {
        setLoginMessage('Unsuccesful: ' + msg);
        setLoginMessageError(true);
    }

    const printSuccessfulLoginMessage = (msg) => {
        setLoginMessage(msg);
        setLoginMessageError(false);
    }

    const handleKeyPress = (event) => {
        // Check if the pressed key is 'Enter'
        if (!loginValue) {
            return;
        }
        if (event.key === 'Enter') {
          handleLoginButtonClick();
        }
    };

    const loginPlayerOnServer = async (playerId) => {
        // Make a POST request to login player on server
        const postResponse = await axiosAuth.post(loginPlayerApiUrl + encodeURIComponent(playerId));
        console.log('POST RESPONSE', postResponse);

        return postResponse.data;
    };

    // Function to handle login button click and validate input
    const handleLogin = async () => {
        if (loginInputValue.trim() === '') {
            setLoginMessageError(false);
            setLoginMessage('');
            return
        }

        //Check if input player exists, to allow lower case player input
        const truePlayerName = Object.values(teamData.players).find(
            (player) => player.toLowerCase() === loginInputValue.toLowerCase()
        );

        // Get playerId for player
        const playerId = Object.keys(teamData.players).find(
            key => teamData.players[key] === truePlayerName
        );

        const retries = 3;
        let currentGameData = nextGameData;
        for (let i = 0; i < retries; i++) {
            try {
                // If previous attempt to push failed, try to update local data
                if (i > 0) {
                    const gameResponse = await axiosAuth.get(gameApiUrl + currentGameData.dateTimeLocKey);
                    console.log('GET game response:', gameResponse);
                    // If loggedIn is in old array format, convert
                    if (Array.isArray(gameResponse.data.loggedIn)) {
                        const newLoggedIn = {}
                        gameResponse.data.loggedIn.forEach((playerId) => {
                            newLoggedIn[playerId] = { group: "Home" }
                        })
                        gameResponse.data.loggedIn = newLoggedIn;
                    }
                    currentGameData = gameResponse.data;
                }

                // Validate input
                if (playerId in currentGameData.loggedIn) {
                    printUnsuccesfulLoginMessage(loginInputValue + ' is already logged in');
                    setNextGameData(currentGameData);
                    break;
                }
                else if (Object.keys(currentGameData.loggedIn).length >= teamData.maxPlayers) {
                    printUnsuccesfulLoginMessage('Max players has already been reached');
                    setNextGameData(currentGameData);
                    break;
                }
                else if (!(playerId in teamData.players)) {
                    printUnsuccesfulLoginMessage(loginInputValue + ' does not belong to this team, contact your team admin to be added');
                    setNextGameData(currentGameData);
                    break;
                }
                else {
                    // Attempt to update team table value
                    const responseData = await loginPlayerOnServer(playerId); ////////
                    if (responseData.gameData) {
                        setNextGameData(responseData.gameData);
                    }
                    else {
                        // Trigger update of game data by setting teamData
                        setTeamData({ ...teamData })
                    }

                    console.log('Game data update successful');
                    setLoginInputValue('');
                    setLoginValue(null);
    
                    // Log and display a success message
                    console.log(`${truePlayerName} successfully logged in`);
                    printSuccessfulLoginMessage(`${truePlayerName} logged in!`);
                    break;
                }
            }
            catch (error) {
                console.error(`Attempt ${i+1} - Error updating teamData:`, error);
                if (i === retries-1) {
                    printUnsuccesfulLoginMessage('Failed to update Team Data');
                }
            }
        }
    }

    const handleLoginButtonClick = async () => {
        setIsLoggingIn(true);

        await handleLogin();

        setIsLoggingIn(false);
    }

    const filterOptions = (options, { inputValue }) => {
        return options.filter((option) =>
          option.toLowerCase().startsWith(inputValue.toLowerCase())
        );
    };

    return (
        <div className='player-login-container'>
            <div className='player-input-container'>
                <Autocomplete
                    disablePortal
                    id="login-input"
                    filterOptions={filterOptions}
                    options={playerOptions}
                    value={loginValue}
                    onChange={(event, newValue) => {
                        setLoginValue(newValue);
                        console.log("nv:", newValue);
                    }}
                    freeSolo
                    inputValue={loginInputValue}
                    onInputChange={(event, newInputValue) => {setLoginInputValue(newInputValue);console.log(newInputValue);}}
                    sx={{
                        width: 240
                    }}
                    onKeyDown={handleKeyPress}
                    renderInput={(params) => <TextField {...params} error={loginMessageError} label="Player Name" helperText={loginMessage} FormHelperTextProps={{sx: {color: 'green'}}}/>}
                />
            </div>
            <div className='login-button'>
                <Button variant="contained" onClick={handleLoginButtonClick} disabled={isLoggingIn}>
                    Login
                </Button>
            </div>
        </div>
      );
}

export default LoginInput;